// extracted by mini-css-extract-plugin
export default {"wechat-account":"index_wechat-account__x64MG","action":"index_action__hZMW5"};